import { videoUIDs } from '../utilities/isVideoTransferSyntax.js';
const VIDEO_SOP_CLASS_UIDS = new Set([
    '1.2.840.10008.5.1.4.1.1.77.1.2.1',
    '1.2.840.10008.5.1.4.1.1.77.1.4.1',
    '1.2.840.10008.5.1.4.1.1.77.1.1.1',
]);
const SECONDARY_CAPTURE_SOP_CLASS_UIDS = new Set([
    '1.2.840.10008.5.1.4.1.1.7',
    '1.2.840.10008.5.1.4.1.1.7.4',
]);
function getTransferSyntaxUids(instance) {
    const tsuid = instance.AvailableTransferSyntaxUID ||
        instance.TransferSyntaxUID ||
        instance['00083002'];
    return (Array.isArray(tsuid) ? tsuid : [tsuid]).filter((value) => typeof value === 'string' && value.length > 0);
}
export function isVideoInstance(instance) {
    const tsuids = getTransferSyntaxUids(instance);
    if (tsuids.some((tsuid) => videoUIDs.has(tsuid))) {
        return true;
    }
    if (instance.SOPClassUID === '1.2.840.10008.5.1.4.1.1.77.1.4.1') {
        return true;
    }
    if (VIDEO_SOP_CLASS_UIDS.has(instance.SOPClassUID ?? '')) {
        return true;
    }
    const numberOfFrames = Number(instance.NumberOfFrames) || 0;
    return (SECONDARY_CAPTURE_SOP_CLASS_UIDS.has(instance.SOPClassUID ?? '') &&
        numberOfFrames >= 90);
}
